import { WidgetProps } from '@rjsf/utils';
import { TextField } from '@mui/material';

type Resize = 'none' | 'both' | 'horizontal' | 'vertical' | 'initial' | 'inherit';

const ResizableTextarea = (props: WidgetProps) => {
  const { id, value, required, disabled, readonly, label, onChange, onBlur, onFocus, options = {} } = props;

  const rows = options.rows || 8;
  const resize = options.resize || 'vertical';

  return (
    <TextField
      id={id}
      value={value || ''}
      required={required}
      disabled={disabled || readonly}
      label={label}
      multiline
      rows={rows}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur && ((e) => onBlur(id, e.target.value))}
      onFocus={onFocus && ((e) => onFocus(id, e.target.value))}
      inputProps={{
        style: {
          resize: resize as Resize,
          ...(options.style || {}),
        },
      }}
    />
  );
};

export default ResizableTextarea;
